'use strict';

exports.__esModule = true;
exports['default'] = componentDidUpdate;

var _property = require('../others/property');

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function componentDidUpdate(value) {
  return (0, _property2['default'])('componentDidUpdate', value);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/lifecycle/componentDidUpdate.js
// module id = 579
// module chunks = 1